import { useCallback } from 'react';
import { useMutation } from 'react-apollo';
import updatePreferencesGql from '../updatePreferences.graphql';
import meGql from '../withCurrentUser.graphql';
import useCurrentUser from './useCurrentUser';
const useUserPreferences = () => {
    const { me, systemConfig, loading: loadingUser } = useCurrentUser();
    const { preferences, accessList } = me || {};
    const gqlOptions = {
        refetchQueries: [{ query: meGql }],
        awaitRefetchQueries: true,
    };
    const [updatePreferencesMutation, { error, loading },] = useMutation(updatePreferencesGql, gqlOptions);
    const updatePreferences = useCallback(async (params) => {
        const result = me.id
            ? await updatePreferencesMutation({
                variables: {
                    personId: me.id,
                    params,
                },
            })
            : undefined;
        return {
            loading,
            error,
            result,
        };
    }, [me, updatePreferencesMutation, loading, error]);
    return {
        accessList,
        preferences,
        systemConfig,
        updatePreferences,
        me,
        loading: loadingUser || loading,
    };
};
export default useUserPreferences;
